<style lang="less">
.container {
  width: 718px;
  height: 100%;
  background: #f7f7f7;
  padding: 16px;
  .Trend-top-content {
    background: #fff;
    padding: 24px;
    width: 670px;
    height: 442px;
    position: relative;
    .Trend-top-title {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .title-text {
        font-size: 32px;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        color: rgba(35, 44, 55, 1);
        line-height: 44px;
        margin-right: 8px;
      }
      .title-img {
        width: 26px;
        height: 26px;
      }
    }
  }
  .Trend-center-content {
    background: #fff;
    padding: 24px;
    width: 670px;
    height: 550px;
    position: relative;
    .Trend-center-title {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .title-text {
        font-size: 26px;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        color: rgba(35, 44, 55, 1);
        line-height: 44px;
        margin-right: 8px;
      }
    }
    .charts-bar {
      width: 100%;
      height: 100%;
    }
  }
  .Trend-footer-content {
    background: #fff;
    padding: 24px;
    width: 670px;
    margin-top: 18px;
    margin-bottom: 190px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .trading-area {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 8px 32px;
      .trading-area-title {
        font-size: 26px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(137, 147, 159, 1);
        line-height: 36px;
      }
      .trading-area-info {
        font-size: 32px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(35, 44, 55, 1);
        line-height: 44px;
        margin-top: 12px;
      }
    }
  }
}
.page {
  width: 100%;
  height: 100%;
  background-color: #fff;
}

.circle-box {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.circle {
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
}
.circle-nei {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .draw_btn {
    font-size: 108px;
    font-family: Arial-BoldMT;
    font-weight: normal;
    color: rgba(65, 105, 225, 1);
    line-height: 124px;
  }
  .draw_btn-text {
    font-size: 26px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(137, 147, 159, 1);
    line-height: 36px;
  }
}
.van-popup{
  border-radius: 8px;
  width: 560px;
}
.popup-box{
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 22px 38px 40px;
  height: 656px;
  overflow-y: scroll;
  .dialog-title {
    height: 44px;
    font-size: 32px;
    color: rgba(35, 44, 55, 1);
    line-height: 44px;
    margin: 16px 0;
    font-weight: bold;
  }
  .dialog-info {
    text-align: left;
    font-size: 28px;
    color: rgba(111, 120, 132, 1);
    line-height: 40px;
  }
}
.modal-btn-wrapper {
  display: flex;
  flex-direction: row;
  height: 100px;
  line-height: 100px;
  border-top: 2px solid rgba(7, 17, 27, 0.1);
  background: #fff;
}
.confirm-btn {
  flex: 1;
  height: 90px;
  line-height: 90px;
  text-align: center;
  font-size: 32px;
}
</style>
<template>
  <div class="container">
    <div class="Trend-top-content">
      <div class="Trend-top-title">
        <label class="title-text">全市小区综合得分</label>
        <img class="title-img" @click="lookScore" src="../../assets/img/wenhao.png">
      </div>
      <div class="page">
        <div class="circle-box" ref="circle-box">
          <van-circle
            v-model="currentRate"
            color="#4169E1"
            fill="#fff"
            size="156px"
            layer-color="#ebedf0"
            :text="text"
            :speed="80"
            :clockwise="true"
            :stroke-width="30"
            :rate="score"
          >
            <div class="circle-nei">
              <div v-if="score.length>2" class="draw_btn full-score">{{score}}</div>
              <div v-else class="draw_btn no-full">{{score}}</div>
              <div class="draw_btn-text">{{scoreInfo.name}}</div>
            </div>
          </van-circle>
        </div>
      </div>
    </div>
    <div class="Trend-center-content">
      <div class="Trend-center-title">
        <label class="title-text">近半年得分趋势</label>
      </div>
      <!-- <e-charts barData="{{trendInfo}}"></e-charts> -->
      <Bar class="charts-bar" :xData="trendInfo.months" :yData="trendInfo.scores"></Bar>
    </div>
    <div class="Trend-footer-content">
      <div class="trading-area">
        <div class="trading-area-title">总小区数</div>
        <div class="trading-area-info">{{trendInfo.zoneNum}}</div>
      </div>
      <div class="trading-area">
        <div class="trading-area-title">环比上涨小区</div>
        <div class="trading-area-info">{{trendInfo.increaseNum}}</div>
      </div>
      <div class="trading-area">
        <div class="trading-area-title">环比下跌小区</div>
        <div class="trading-area-info">{{trendInfo.decreaseNum}}</div>
      </div>
    </div>
    <van-popup v-model="show">
      <div class="popup-box">
        <div class="dialog-title">选址评分</div>
        <div class="dialog-info">选址评分是业务团队深入了解合作商家，进行实地探访，将其在长租行业的选址经验整合沉淀、量化各类信息维度，经算法分析形成的结果。选址评分主要通过对城市配套和市场表现两个方面进行评估，满分为100分，得分越高，越适合长租公寓运营商收房选址。</div>
        <div class="dialog-title">评分维度说明</div>
        <div class="dialog-info">城市配套是指区域范围内的居住条件，包括内部小区品质、周边的交通、生活配套，以及企业和职工密集度等市场表现是指该区域的租房市场体量、实际需求量，和长租市场发展潜力等</div>
        <div class="dialog-title">全市综合得分</div>
        <div class="dialog-info">代表城市所有商圈或小区的选址评分的平均水平。</div>
      </div>
      <div class="modal-btn-wrapper">
        <div class="confirm-btn" style="color:#4169E1" @click="confirmPopup">知道了</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Progress, Popup,Circle } from "vant";
import Bar from "@/components/echarts_bar"
export default {
  name: "detail",
  components: {
    Progress,Bar,
    "van-popup": Popup,
    "van-circle":Circle 
  },
  data() {
    return {
      canvasWidth: 1,
      canvasHeight: 1,
      score: 0,
      cityId: "",
      scoreInfo: {},
      trendInfo: {},
      show:false,
      showEmpty: false,
      currentRate:0
    };
  },
  computed: {
    text() {
      return this.currentRate + '分 \n ' + '2019年1月'
    }
  },
  created() {
    let options = this.$route.query;
    this.cityId = options.cityId;
    this.getZoneAvgScoreTrend(options.cityId);
    this.getZoneAvgScore(options.cityId)
  },
  mounted() {
    this.canvasWidth = this.$refs['circle-box'].clientWidth;
    this.canvasHeight = this.$refs['circle-box'].clientHeight;
  },
  methods: {
    //查看评分标准
    lookScore() {
      this.addBuried({
        source:'1',
        eventType: '点击事件',
        eventContent: '查看评分标准'
      });
      this.show = true;
    },
    confirmPopup() {
      this.show = false;
    },
    //小区平均得分
    getZoneAvgScore(cityId) {
      this.$axios.post(
        "api/xz/score/avg/community/",
        {
          cityId: cityId
        }
      )
        .then(res => {
          if (res.success) {
            this.scoreInfo = res.result;
            this.score = res.result.value;
            // this.drawCircle(this.score);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //小区平均得分走势
    getZoneAvgScoreTrend(cityId) {
      this.$axios.post(
        "api/xz/score/avgtrend/community/",
        {
          cityId: cityId
        },
      )
        .then(res => {
          if (res.success) {
            this.showEmpty = true;
            this.trendInfo = res.result;
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/pages/cell_trend/index.vue